import { Component, Input, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { GlobalMessageService, GlobalMessageType } from '@spartacus/core'
import { LaunchDialogService } from '@spartacus/storefront'
import { BulkServiceService } from '../bulk-service.service'
import { DialogResponse, VS_LAUNCH_CALLER } from '../../config/dialog.config'
@Component({
  standalone: false,
  selector: 'vs-bulk-order-modal',
  templateUrl: './bulk-order-modal.component.html',
  styleUrls: ['./bulk-order-modal.component.scss'],
})
export class BulkOrderModalComponent implements OnInit {
  @Input() getFailuresCount: number
  public hideSuccessList: boolean = true
  priceNotAvailableinSAPProducts: any

  constructor(
    private launchDialogService: LaunchDialogService,
    private router: Router,
    private globalMessageService: GlobalMessageService,
    private bulkService: BulkServiceService
  ) {}
  dismissModal(reason?: any): void {
    const dialogResponse: DialogResponse = {
      reason: reason,
      type: VS_LAUNCH_CALLER.BULK_ORDER,
    }
    this.launchDialogService.closeDialog(dialogResponse)
  }
  sendSuccessFlag() {
    sessionStorage.setItem('nonSellableProd', 'true')
  }
  ngOnInit(): void {
    this.bulkService.priceNotAvailableinSAPProducts.subscribe((products) => {
      this.priceNotAvailableinSAPProducts = products
    })
  }
}
